/** Convert a pixel value (passed in as just a number) to the corresponding
 * `rem` value. */
const rem = px => `${px / 16}rem`

export default rem
